import React, {forwardRef, useState, memo} from 'react';

const CustomTextCellEditor = memo(forwardRef((props, ref) => {
  const [value, setValue] = useState(props.value);

  const handleChange = (newValue) => {
    setValue(newValue);
    newValue = newValue == '' ? null : props.colDef.valueParser({newValue: newValue})
    props.onValueChange(applyPreDefinedValueConstraint(newValue));
  };

  const applyPreDefinedValueConstraint = (value) => {
    let {has_dependency = false, dependency_settings = {}} = props.colDef?.cellRendererParams?.original;

    if (!has_dependency || dependency_settings['no_mapping_defined']) {
      return value; // return if there is no dependency
    }

    let dependency = dependency_settings['accessor'];
    let dependencyValue = props.data[dependency];
    let valueConstraint = ((dependency_settings['mapping']||{})[`option-${dependencyValue}`]||{})['value_constraint'];

    switch (valueConstraint) {
      case 'negative':
        return value > 0 ? -value : value;
      case 'positive':
        return Math.abs(value);
      default:
        return value;
    }
  };

  return (
    <input
      type='text'
      value={value}
      onChange={(e) => handleChange(e.target.value)}
      style={{width: '100%'}}
      autoFocus
    />
  );
}));

export default CustomTextCellEditor;
